export const mobileVideoHeaderStyles = {
	overflow: 'hidden',
	aspectRatio: '1/1.13',
	display:'flex',
	justifyContent: 'center',
	alignItems: 'center',
	flexDirection: 'column'
}